import { Link, useLocation } from 'react-router-dom';
import { Check, Circle } from 'lucide-react';
import { cn } from '@/lib/utils';

export type StepStatus = 'todo' | 'active' | 'done';

export type Step = {
  key: string;
  label: string;
  to: string;
  status: StepStatus;
};

export function StepRail({ steps }: { steps: Step[] }) {
  const location = useLocation();
  return (
    <nav
      aria-label="Onboarding progress"
      data-testid="step-rail"
      className="flex flex-col gap-1 rounded-card border border-brand-outline-variant/20 bg-card p-3 shadow-l1"
    >
      {steps.map((step) => {
        const is_current = location.pathname === step.to || step.status === 'active';
        return (
          <Link
            key={step.key}
            to={step.to}
            data-testid={`step-${step.key}`}
            data-status={step.status}
            className={cn(
              'flex items-center gap-3 rounded-lg px-3 py-2 text-sm font-semibold transition-colors',
              is_current && 'bg-secondary text-foreground',
              !is_current && 'text-muted-foreground hover:bg-secondary/60 hover:text-foreground',
              step.status === 'done' && !is_current && 'text-foreground',
            )}
          >
            <span
              className={cn(
                'flex h-6 w-6 items-center justify-center rounded-full border-2',
                step.status === 'done' && 'border-primary bg-primary text-primary-foreground',
                step.status === 'active' && 'border-primary text-primary',
                step.status === 'todo' && 'border-border text-muted-foreground',
              )}
            >
              {step.status === 'done' ? (
                <Check className="h-3.5 w-3.5" />
              ) : (
                <Circle className="h-2 w-2 fill-current" />
              )}
            </span>
            <span className="flex-1 truncate">{step.label}</span>
          </Link>
        );
      })}
    </nav>
  );
}
